import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/mapto";
import "rxjs/add/operator/mergeMap";
import "rxjs/add/operator/switchMap";
import { concat as concat$ } from "rxjs/observable/concat";
import * as ErrorHandler from "../common/errorHandler";
import { serviceApi } from "../services/summarydata.service";

import {
    GET_SURVEY_RESULTS_REQUEST,
    GET_PLOT_EVENTS_COUNT_REQUEST,
    GET_METADATA_REQUEST,

    IGetSurveyResultsRequestAction,
    IGetPlotEventsCountRequestAction,
    IGetMetadataRequestAction,

    getSurveyResultsSuccess,
    getPlotEventsCountSuccess,
    getMetadataSuccess
} from "../actions/summarydata.actions";

export const getSurveyResults = action$ =>
    action$
        .ofType(GET_SURVEY_RESULTS_REQUEST)
        .mergeMap((action: IGetSurveyResultsRequestAction) =>
            serviceApi
                .getSurveyResults(action.userGroupId, action.userId, action.surveyCode, action.plotEventCreatedStartDate, action.plotEventCreatedEndDate)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getSurveyResultsSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );


export const getPlotEventsCount = action$ =>
    action$
        .ofType(GET_PLOT_EVENTS_COUNT_REQUEST)
        .mergeMap((action: IGetPlotEventsCountRequestAction) =>
            serviceApi
                .getPlotEventsCount(action.groupId, action.userId, action.plotEventStartDateStart, action.plotEventStartDateEnd, action.classificationIds, action.mustIncludeClassificationId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getPlotEventsCountSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );


export const getMetadata = action$ =>
    action$
        .ofType(GET_METADATA_REQUEST)
        .mergeMap((action: IGetMetadataRequestAction) =>
            serviceApi
                .getMetadata(action.groupId, action.userId)
                .mergeMap(response => {
                    return concat$(
                        Observable.of(getMetadataSuccess(response))
                    )
                })
                .catch((error) => ErrorHandler.FireErrorActions(error))
        );